module.exports = __webpack_public_path__ + "static/media/features-timesheets.617486f6.png";